import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { NotificationMessages } from '../../Models/Notifications/NotifiyMessages';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { takeUntil, finalize } from 'rxjs';
import { BaseComponent } from '../../Base/base/base.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-competitive-integence',
  standalone: false,
  templateUrl: './competitive-integence.component.html',
  styleUrl: './competitive-integence.component.css'
})
export class CompetitiveIntegenceComponent extends BaseComponent{
loading:boolean=false;
 userId:string
 latestTimestamp!: string;
 notifications:NotificationMessages[]=[]
 userRole!:string
 SingleNotification!:NotificationMessages
 visible:boolean=false;
 ShowDialog(notification:NotificationMessages){
   this.SingleNotification=notification;
   this.visible=true;
 }

 pageNumber: number = 1;
 canGoNext = false;
 canGoPrev = false;
 trackByNotificationId(index: number, item: NotificationMessages): string {
  return item.id;
}
 constructor
  (
    private messageService:MessageService,
    private auth:AuthService,
    private api:BaseApiService,
    private sanitizer: DomSanitizer,
  ) {
    super();
    this.userId   =this.auth.getUID();
    this.userRole =this.auth.getRoles().toString();

  }



   GetNotifications(userId:string){
        this.loading=true;
        this.api.read(`Profile_Service/NotificationsPages?userid=${userId}&type=CompetitiveIntegence&pageNumber=${this.pageNumber}`)
         .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.loading = false;
          })
         )
        .subscribe
        (
           {
            next:(response)=>{
              this.notifications = response.map((item: any) => {
                const { sanitizedHtml, imageSrc } = this.sanitizeHtmlWithImageFix(item.message);
            
                return {
                  ...item,
                  isRead: item.isRead ?? false,
                  workflowStep: item.workflowStep ?? null,
                  createdAt: item.createdAt ? new Date(item.createdAt) : new Date(),
                  updatedAt: item.updatedAt ? new Date(item.updatedAt) : new Date(),
                  timestamp: item.timestamp ? new Date(item.timestamp) : new Date(),
                  sanitizedHtml,
                  imageSrc
                } as NotificationMessages;
              });
              this.loading         = false;
              // Optional: Disable "Next" if returned items < 7
              this.canGoNext = response.length === 7;
              this.canGoPrev = this.pageNumber > 1;
    
    
            },
            error:(
              error
            )=>{
              this.loading=false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            }
           }
        )
      }
      goToNext(userId: string) {
        if (this.canGoNext) {
          this.pageNumber++;
          this.GetNotifications(userId);
        }
      }
      
      goToPrev(userId: string) {
        if (this.pageNumber > 1) {
          this.pageNumber--;
          this.GetNotifications(userId);
        }
      }
  
  ngOnInit() {
    this.GetNotifications(this.userId);
  }

   sanitizeHtml(htmlContent: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
      }
     
      sanitizeHtmlWithImageFix(html: string) {
       const tempDiv = document.createElement('div');
       tempDiv.innerHTML = html;
     
       const images = tempDiv.querySelectorAll('img');
       let imageSrc = '';
     
       images.forEach((img: HTMLImageElement, index: number) => {
         img.style.maxWidth = '100%';
         img.style.height = 'auto';
         img.style.objectFit = 'cover';
         img.classList.add('img-fluid', 'rounded-2', 'shadow', 'my-2');
     
         if (index === 0) {
           imageSrc = img.src;
           img.remove(); // Optional: remove first image from content
         }
       });
     
       return {
         sanitizedHtml: this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML),
         imageSrc: imageSrc
       };
     }

}
